import { render, staticRenderFns } from "./DonutChart58.vue?vue&type=template&id=72084dc5&scoped=true&"
import script from "./DonutChart58.vue?vue&type=script&lang=js&"
export * from "./DonutChart58.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72084dc5",
  null
  
)

export default component.exports